// let tzoffset = (new Date()).getTimezoneOffset() * 60000
// let localISOTime = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)

import defaultDireccionForm from "../util/defaultDireccionForm";
import { clone } from "./libUtil"

const defaultTtForm = {
    nombre: '',
    cups: null,
    iban: null,
    documento: null,
    tipoDocumento: 'NIF',
    telefonosContacto: [],
    email: '',
    // cp: '',
    // localidad: '',
    // fechaContacto: localISOTime,
    origenBbdd: null,
    segmento: null,
    // comercial: {},
    ispActual: null,
    razonNoInteresado: null,
    // notas: null,
    direccion: clone(defaultDireccionForm)
}

export { defaultTtForm };
